export default function CoursesPanel() {
    return <div className="hidden"></div>;
}
